import { Component, Inject, TemplateRef, ViewChild, ViewEncapsulation } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { fuseAnimations } from "@fuse/animations";
import { map, Observable } from "rxjs";

import { BaseComponent, LoadingTeste } from "app/base-module/base-component/base.component";

import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AcaoComercial } from "app/acao-comercial/model/acao-comercial.model";
import { AcaoComercialService } from "app/acao-comercial/services/acao-comercial.service";
import { StatusMovimentacao } from "app/auxiliares/models/status-movimentacao.model";
import { StatusMovimentacaoService } from "app/auxiliares/services/status-movimentacao.service";
import { AuthService } from "app/base-module/base-service/auth.service";
import { ClienteModel } from "app/clientes/models/cliente.model";
import { ClienteService } from "app/clientes/services/cliente.service";
import { BoletaCoeService } from "../services/boleta-coe.service";
import { CaracteristicaCoeService } from "../services/caracteristica-coe.service";

export interface DialogData {
    acao_comercial_id: number;
    cliente_id: number;
    id: number;
    historico: boolean;
}

@Component({
    selector: "app-cadastro-boleta-coe",
    templateUrl: "./cadastro-boleta-coe.component.html",
    styleUrls: ["./cadastro-boleta-coe.component.scss"],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class CadastroBoletaCoeComponent extends BaseComponent {
    valor = new FormControl<number>(0, [Validators.required]);
    caracteristica = new FormControl<any | null>(null, [Validators.required]);
    data_futura = new FormControl();
    dinheiro_novo = new FormControl("DN", [Validators.required]);
    cliente = new FormControl<any | null>(null, [Validators.required]);
    cliente_id = new FormControl("", [Validators.required]);
    acao_comercial_id = new FormControl();
    status_id = new FormControl();
    qtd = new FormControl();
    receita_recebida = new FormControl(0);
    vlr_spread = new FormControl(0);
    compra_venda = new FormControl("COMPRA", [Validators.required]);

    model: any = {
        caracteristica_id: "",
        acao_comercial_id: "",
    };

    loadingLocal: any;
    titulo!: string;
    texto!: string;
    listCaracteristica: any[] = [];
    listStatus: StatusMovimentacao[] = [];
    listAcaoComercial: AcaoComercial[] = [];
    loadingSpinnerCaracteristica: boolean = false;
    loadingSpinnerAcaoComercial: boolean = false;
    loadingSpinnerStatus: boolean = false;
    loadingSpinner!: boolean;
    filteredOptions!: Observable<ClienteModel[]>;
    filteredOptionsCaracteristica!: Observable<any[]>;

    @ViewChild("addButtonTmpl", { static: false })
    addButtonTmpl!: TemplateRef<any>;

    constructor(
        public _boletaService: BoletaCoeService,
        private _serviceCaracteristica: CaracteristicaCoeService,
        public dialog: MatDialog,
        override snackBar: MatSnackBar,
        private loading: MatDialog,
        public authService: AuthService,
        public dialogRef: MatDialogRef<CadastroBoletaCoeComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        private _clienteService: ClienteService,
        private _statusService: StatusMovimentacaoService,
        private _serviceAcaoComercial: AcaoComercialService
    ) {
        super(dialog, snackBar);
        this.getAllStatus();
        this.getAllAcaoComercial();

        if (this.data.id != null) {
            this.getBoleta();
        }

        this.cliente.valueChanges.subscribe((query) => {
            if (typeof query === "string" || typeof query === "number") {
                this.loadingSpinner = true;
                const parametrosCliente = {
                    search: query,
                };
                this.filteredOptions = this._clienteService.search(parametrosCliente).pipe(map(response => response.data));
            }
        });

        this.caracteristica.valueChanges.subscribe((query) => {
            if (typeof query === "string" || typeof query === "number") {
                this.loadingSpinnerCaracteristica = true;
                this.params.search = query;
                this.params.historico = this.data.historico;
                this.filteredOptionsCaracteristica = this._serviceCaracteristica.search(this.params);
            }
        });
    }

    displayFn(cliente: any) {
        if (cliente) {
            return cliente.nome;
        }
    }

    displayFnCarateristica(caracteristica: any) {
        if (caracteristica) {
            return caracteristica.nome;
        }
    }

    getCliente(cliente: any) {
        this.loadingSpinner = false;
    }

    getCaracteristica(caracteristica: any) {
        this.vlr_spread.setValue(caracteristica.vlr_roa || 0);
        this.loadingSpinnerCaracteristica = false;
        this.getReceitaRecebidaAssessor();
    }

    onNoClick(): void {
        this.dialogRef.close("cancel");
    }

    /**
     * Abre loagind
     */
    openLoadingLocal(): void {
        this.loadingLocal = this.loading.open(LoadingTeste, {
            width: "150px",
            disableClose: true,
        });
    }

    /**
     * Fecha loagind
     */
    closeLoadingLocal(): void {
        if (this.loadingLocal != null) {
            this.loadingLocal.close();
        }
    }

    isInvalidForm() {
        if (!this.valor.valid) {
            return true;
        }

        if (!this.compra_venda.valid) {
            return true;
        }

        return false;
    }

    salvar() {
        this.openLoading();
        if (this.data.cliente_id != null) {
            this.model.cliente_id = this.data.cliente_id;
        } else {
            const novaBoletaCliente = this.cliente.value;
            this.model.cliente_id = novaBoletaCliente.id;
        }
        const caracteristica = this.caracteristica.value;

        this.model.valor = this.valor.value;
        this.model.acao_comercial_id = this.acao_comercial_id.value;
        this.model.caracteristica_id = caracteristica.id;
        this.model.dinheiro_novo = this.dinheiro_novo.value;
        this.model.data_futura = this.data_futura.value;
        this.model.status_id = this.status_id.value;
        this.model.qtd = this.qtd.value;
        this.model.compra_venda = this.compra_venda.value;

        if (this.data.id == null) {
            this._boletaService.create(this.model).subscribe(
                (data) => {
                    this.closeLoading();
                    this.dialogRef.close(data);
                },
                (error) => {
                    this.closeLoading();
                    this.showError(error.error.message);
                },
                () => {
                    this.closeLoading();
                }
            );
        } else {
            this._boletaService.update(this.data.id, this.model).subscribe(
                (data) => {
                    this.closeLoading();
                    this.dialogRef.close(data);
                },
                (error) => {
                    this.closeLoading();
                    this.showError(error.error.message);
                },
                () => {
                    this.closeLoading();
                }
            );
        }
    }

    getAllStatus() {
        this.loadingSpinnerStatus = true;

        this._statusService.getLista({ tipo_produto: "CO" }).subscribe(
            (list) => {
                this.listStatus = list.data ?? [];
            },
            (error) => { },
            () => {
                this.loadingSpinnerStatus = false;
            }
        );
    }

    getErrorValorMessage() {
        return this.valor.hasError("required") ? "Valor é um campo obrigatório" : "";
    }

    getBoleta() {
        this.openLoading();
        this._boletaService.getById(this.data.id).subscribe(
            (boleta) => {
                this.valor.setValue(boleta.data.valor);
                this.caracteristica.setValue(boleta.data.caracteristica);
                this.cliente.setValue(boleta.data.cliente);
                this.cliente_id.setValue(boleta.data.cliente.id);
                this.data_futura.setValue(boleta.data.data_futura);
                this.acao_comercial_id.setValue(boleta.data.acao_comercial_id);
                this.status_id.setValue(boleta.data.status_id);
                this.qtd.setValue(boleta.data.qtd);
                this.compra_venda.setValue(boleta.data.compra_venda);

                if (boleta.data.dinheiro_novo) {
                    this.dinheiro_novo.setValue("DN");
                } else if (boleta.data.aporte_futuro) {
                    this.dinheiro_novo.setValue("AF");
                } else if (boleta.data.realocacao) {
                    this.dinheiro_novo.setValue("RE");
                }

                this.getCaracteristica(boleta.data.caracteristica);
            },
            (error) => {
                this.closeLoading();
            },
            () => {
                this.closeLoading();
            }
        );
    }

    getAllAcaoComercial() {
        this.loadingSpinnerAcaoComercial = true;

        this._serviceAcaoComercial.getAll({ no_paginate: true }).subscribe(
            (list) => {
                this.listAcaoComercial = list.data;
            },
            (error) => { },
            () => {
                this.loadingSpinnerAcaoComercial = false;
                if (
                    this.data.acao_comercial_id != null &&
                    (this.acao_comercial_id.value == null || this.acao_comercial_id.value == "")
                ) {
                    this.acao_comercial_id.setValue(Number(this.data.acao_comercial_id));
                    this.model.acao_comercial_id = Number(this.data.acao_comercial_id);
                }
            }
        );
    }

    getReceitaRecebidaAssessor() {
        let valor = 0;
        if (this.valor.value && this.vlr_spread.value) {
            valor = this.valor.value * (this.vlr_spread.value / 100);
        }
        this.receita_recebida.setValue(valor);
    }
}
